import React from "react";
import { Field, FieldArray } from "formik";
import { TextField, CheckboxWithLabel } from "formik-material-ui"; // import { Debug } from "./Debug";

import { Button, MenuItem, FormControlLabel, Grid } from "../../..";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "wrap",
      padding: "15px 30px"
    },
    button: {
      width: "20px",
      "min-width": "20px"
    },
    mr30: {
      "margin-right": "30px"
    },
    options: {
      display: "flex",
      "align-items": "center",
      "justify-content": "space-evenly"
    },
    isMandatory: {
      margin: 0
    }
  };
});

var FieldsForm = function FieldsForm(_ref) {
  var values = _ref.values,
      mode = _ref.mode;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(FieldArray, {
    name: "extraFields",
    render: function render(_ref2) {
      var insert = _ref2.insert,
          remove = _ref2.remove,
          push = _ref2.push;
      return values.extraFields.length > 0 ? values.extraFields.map(function (field, index) {
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 12,
          className: classes.root,
          key: index
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 3,
          className: classes.fieldName
        }, /*#__PURE__*/React.createElement(Field, {
          name: "extraFields[".concat(index, "].name"),
          component: TextField,
          label: "Name",
          margin: "normal",
          variant: "outlined",
          disabled: mode === "view"
        }), /*#__PURE__*/React.createElement(FormControlLabel, {
          className: classes.isMandatory,
          control: /*#__PURE__*/React.createElement(Field, {
            label: "Mandatory?",
            name: "extraFields[".concat(index, "].isMandatory"),
            component: CheckboxWithLabel,
            color: "primary",
            disabled: mode === "view"
          }),
          label: "Obligatorio"
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 4
        }, /*#__PURE__*/React.createElement(Field, {
          type: "text",
          fullWidth: true,
          name: "extraFields[".concat(index, "].type"),
          label: "Field Type",
          select: true,
          margin: "dense" //helperText="Selecciona un tipo de campo"
          ,
          disabled: mode === "view",
          component: TextField
        }, /*#__PURE__*/React.createElement(MenuItem, {
          value: ""
        }, "Selecciona un tipo"), /*#__PURE__*/React.createElement(MenuItem, {
          value: "checkbox"
        }, "Checkbox"), /*#__PURE__*/React.createElement(MenuItem, {
          value: "select"
        }, "Select"), /*#__PURE__*/React.createElement(MenuItem, {
          value: "text"
        }, "Text"), /*#__PURE__*/React.createElement(MenuItem, {
          value: "textarea"
        }, "Text Area"), /*#__PURE__*/React.createElement(MenuItem, {
          value: "number"
        }, "Number"))), field.type === "select" && /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 3
        }, /*#__PURE__*/React.createElement(FieldArray, {
          name: "extraFields[".concat(index, "].options"),
          render: function render(_ref3) {
            var remove = _ref3.remove,
                push = _ref3.push;
            return /*#__PURE__*/React.createElement(Grid, {
              container: true
            }, field.options.length && field.options.map(function (opt, idx) {
              return /*#__PURE__*/React.createElement(Grid, {
                item: true,
                md: 12,
                className: classes.options
              }, /*#__PURE__*/React.createElement(Field, {
                type: "text",
                name: "extraFields[".concat(index, "].options[").concat(idx, "].name"),
                label: "Options",
                margin: "normal",
                component: TextField,
                disabled: mode === "view"
              }), /*#__PURE__*/React.createElement(Button, {
                className: classes.button,
                disabled: values.extraFields[index].options.length === 1 || mode === "view",
                type: "button",
                color: "secondary",
                variant: "outlined",
                onClick: function onClick() {
                  return remove(idx);
                }
              }, "-"), /*#__PURE__*/React.createElement(Button, {
                type: "button",
                className: classes.button,
                disabled: mode === "view",
                color: "primary",
                variant: "outlined",
                onClick: function onClick() {
                  return push({
                    name: ""
                  });
                }
              }, "+"));
            }));
          }
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          md: 6
        }, /*#__PURE__*/React.createElement(Button, {
          type: "button",
          size: "small",
          disabled: mode === "view",
          className: classes.mr30,
          color: "secondary",
          variant: "outlined",
          onClick: function onClick() {
            return remove(index);
          }
        }, "Remove field"), /*#__PURE__*/React.createElement(Button, {
          type: "button",
          className: classes.mr30,
          size: "small",
          color: "primary",
          variant: "outlined",
          disabled: mode === "view",
          onClick: function onClick() {
            return push({
              name: "",
              type: "select",
              isMandatory: false,
              options: [{
                name: ""
              }]
            });
          }
        }, "Add field")));
      }) : /*#__PURE__*/React.createElement(Button, {
        type: "button",
        className: classes.mr30,
        size: "small",
        color: "primary",
        variant: "outlined",
        disabled: mode === "view",
        onClick: function onClick() {
          return push({
            name: "",
            type: "select",
            isMandatory: false,
            options: [{
              name: ""
            }]
          });
        }
      }, "Add field");
    }
  }));
};

FieldsForm.defaultProps = {
  mode: 'add'
};
export { FieldsForm };